import React from 'react';
import PropTypes from 'prop-types';
import NotiBanner from '@bd-uikit-web/React/NotiBanner';
import bdAuth from '@bd-uikit-web/js-helpers/bdAuth';
import rootDispatcher from '@bd-uikit-web/js-helpers/rootDispatcher';

import AuthOverlay from './AuthOverlay';

import { Route, Switch } from 'react-router-dom';

import Sidebar from '../components/Sidebar';
import Header from '../components/Header';

import Register from './Register.jsx';
import ForgotPassword from './ForgotPassword.jsx';
import ResetPassword from './ResetPassword.jsx';
import Overview from './Overview.jsx';
import Subscriptions from './Subscriptions.jsx';
import Invoice from './Invoice.jsx';
import Editprofile from './EditProfile.jsx';
import PurchaseSubscription from './PurchaseSubscription.jsx';
import Redeem from './Redeem.jsx';
import Login from './Login.jsx';
import ThankYou from './ThanksYou.jsx';

export default class App extends React.Component {
  constructor(props) {
    super();

    this.props = props;
    this.state = {
      showSideBar: false,
      loading: true
    };
    this.search = this.search.bind(this);
    this.logout = this.logout.bind(this);
    this.onLogin = this.onLogin.bind(this);
  }

  componentWillMount() {
    rootDispatcher.on('LOGIN', this.onLogin);
    rootDispatcher.on(
      ['AUTH:UNAUTHORIZED', 'AUTH:INTERNAL_SERVER_ERROR', 'REQ:REQUEST_FAILED'],
      this.showErrorScreen.bind(this)
    );
  }

  componentWillUnmount() {
    rootDispatcher.off('LOGIN', this.onLogin);
    rootDispatcher.off(
      ['AUTH:UNAUTHORIZED', 'AUTH:INTERNAL_SERVER_ERROR', 'REQ:REQUEST_FAILED'],
      this.showErrorScreen.bind(this)
    );
  }

  showErrorScreen({ status }) {
    if (!this.getActiveRoute().public) {
      this.setState({ errorCode: status || '000' });
    }
  }

  onLogin() {
    const { user, artist } = bdAuth.getUser(true);
    this.setState({ loading: false, user, artist });
  }

  logout() {
    bdAuth.clear();
    location.href = bdAuth.getLoginURL('/register');
    this.setState({ user: {}, errorCode: null });
  }

  getActiveRoute() {
    const loc = this.props.location.pathname.split('/');
    return {
      cleanPath: this.props.location.pathname,
      public: ['/login', '/register', '/forgot-password', '/reset-password'].includes(`/${loc[1]}`)
    };
  }

  search(field) {
    const search = this.props.location.search
      .slice(1)
      .split('&')
      .map((p) => p.split('='))
      .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    return search[field];
  }

  render() {
    const activeRoute = this.getActiveRoute();

    if (activeRoute.public) {
      return (
        <div>
          <NotiBanner />
          <main>
            <Route path="/login" render={(props) => <Login {...props} />} />
            <Route path="/register" render={(props) => <Register {...props} />} />
            <Route exact path="/forgot-password" render={(props) => <ForgotPassword {...props} />} />
            <Route exact path="/reset-password/:token" render={(props) => <ResetPassword {...props} />} />
          </main>
        </div>
      );
    }

    if (!bdAuth.isAuthenticated()) {
      if (!this.search('redirect-url')) {
        const prefix = this.props.location.search.includes('?') ? '&' : '?';
        this.props.location.search += prefix + 'redirect-url=' + this.props.location.pathname;
      }
      this.props.history.push(`/login${this.props.location.search}`);
      return null;
    }

    return (
      <div>
        <NotiBanner />

        <Sidebar
          props={this.props}
          onCloseClick={() => this.setState({ showSideBar: false })}
          items={[
            {
              icon: 'social-buffer',
              route: '',
              title: 'Account Overview'
            },
            {
              icon: 'compose',
              route: 'subscriptions',
              title: 'Subscriptions'
            },
            {
              icon: 'person',
              route: 'edit-profile',
              title: 'Edit Profile'
            },
            {
              icon: 'ribbon-b',
              route: 'redeem',
              title: 'Redeem Code'
            }
          ]}
          open={this.state.showSideBar}
          activeRoute={activeRoute.cleanPath}
        />

        <Header onMenuClick={() => this.setState({ showSideBar: !this.state.showSideBar })} />
        <main className="page-main">
          <Switch>
            <Route path="/subscriptions" render={(props) => <Subscriptions {...props} />} />
            <Route path="/thank-you" render={(props) => <ThankYou {...props} />} />
            <Route path="/invoice/:invoiceId" render={(props) => <Invoice {...props} />} />
            <Route path="/edit-profile" render={(props) => <Editprofile {...props} />} />
            <Route path="/redeem" render={(props) => <Redeem {...props} />} />
            <Route path="/purchase-subscription/:plan" render={(props) => <PurchaseSubscription {...props} />} />
            <Route path="/" render={(props) => <Overview {...props} />} />
          </Switch>
        </main>
      </div>
    );
  }
}

App.contextTypes = {
  // router: PropTypes.element.isRequired,
};

App.propTypes = {
  routes: PropTypes.array,
  match: PropTypes.object,
  location: PropTypes.object,
  history: PropTypes.object
};
